var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-field",
      attrs: { "extension-name": "login-input-field" }
    },
    [
      !!_vm.value
        ? _c("label", { staticClass: "login-page-field-label" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")
          ])
        : _c("label", { staticClass: "login-page-field-label" }),
      _vm._v(" "),
      _c("div", { staticClass: "input-field" }, [
        _c("input", {
          attrs: {
            type: _vm.type,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled
          },
          domProps: { value: _vm.value },
          on: {
            input: _vm.textChanged,
            focus: function($event) {
              return _vm.$emit("focus")
            },
            blur: function($event) {
              return _vm.$emit("blur")
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.$emit("enter")
            }
          }
        }),
        _vm._v(" "),
        _c("span", { class: _vm.validationStatusClass })
      ]),
      _vm._v(" "),
      _vm.value &&
      _vm.showPasswordStrength &&
      !_vm.showErrorMessage &&
      _vm.passwordStrengthState
        ? _c(
            "div",
            { staticClass: "login-page-field-password-strength" },
            [
              _vm._l(_vm.numberOfPasswordStrengthStates, function(eachState) {
                return _c("div", {
                  staticClass: "login-page-field-password-strength-bar",
                  style: { "background-color": _vm.passwordStrengthState.color }
                })
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "login-page-field-password-strength-label" },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm._f("translate")(
                          "LoginPageField.PasswordStrengthLabel"
                        )
                      ) +
                      "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "login-page-field-password-strength-value",
                  style: { color: _vm.passwordStrengthState.color }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.passwordStrengthState.msg) +
                      "\n\t\t"
                  )
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showErrorMessage
        ? _c(
            "div",
            {
              staticClass: "login-page-field-error-message",
              attrs: { a_id: "login-page-field-error-message" }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.errorMessage) + "\n\t")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb570ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb570ae","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/LoginPageField.vue
// module id = 437
// module chunks = 0